import axios from "axios";
import Constants from "../../Constants/Constants";
import { AppDispatch } from "../store";
import AuthTypes from "./AuthTypes";
import toast from "react-hot-toast";
import {
  deleteStorage,
  getStorage,
  setStorage,
} from "../../Util/storageHelper";
import { NavigateFunction } from "react-router-dom";
import setAuthHeaders from "../../Util/setAuthHeader";

export const loginUser =
  (
    credentials: { email: string; password: string },
    navigate: NavigateFunction
  ) =>
  async (dispatch: AppDispatch) => {
    dispatch({ type: AuthTypes.LOGIN_LOADING });

    try {
      const { data } = await axios.post(
        `${Constants.apiUrl}/auth/login`,
        credentials
      );

      dispatch({
        type: AuthTypes.LOGIN_SUCCESS,
        payload: {
          token: data?.token,
          user: data?.user,
        },
      });
      setStorage("userData", { token: data?.token, user: data?.user });
      setAuthHeaders(data?.token);
      navigate("/admin");
    } catch (error: any) {
      if (error?.response?.data?.message) {
        toast.error(error?.response?.data?.message);
      } else {
        toast.error("An error occured");
      }
      dispatch({
        type: AuthTypes.LOGIN_ERROR,
        payload: JSON.stringify(error),
      });
    }
  };

export const verifyUser =
  (credentials: { token: string }) => async (dispatch: AppDispatch) => {
    dispatch({ type: AuthTypes.VERIFY_LOADING });

    try {
      await axios.post(`${Constants.apiUrl}/auth/verify`, credentials);

      const userData = getStorage("userData");

      dispatch({
        type: AuthTypes.VERIFY_SUCCESS,
        payload: {
          token: userData?.token,
          user: userData?.user,
        },
      });
      setAuthHeaders(userData?.token);
    } catch (error: any) {
      dispatch({
        type: AuthTypes.VERIFY_ERROR,
        payload: JSON.stringify(error),
      });
      deleteStorage("userData");
    }
  };

export const logoutUser = () => async (dispatch: AppDispatch) => {
  dispatch({
    type: AuthTypes.LOGOUT,
  });
  setAuthHeaders("");
  deleteStorage("userData");
};
